<template>
  <div v-if="showLittleTag">
    <q-card
      :class="['container-indicador shadow-1', disableOpenURL? '': 'cursor-pointer']"
      @click="openURL"
    >
      <div class="row containerHeader">
        <div v-if="showLittleTag" class="title">
          <div class="col-12">
            {{ nameIndicador }}
          </div>
        </div>
        <div class="measuring-container col-12 text-right">
          <div v-if="chartData.length" class="col-12">
            <span class="measuring">{{ String(parseFloat(valueIndicador).toFixed(2)) }} </span>
            <span id="measuring-unit">{{ unidadMedidaIndicador }}</span>
          </div>
          <div class="col-12">
             <span v-if="chartData.length" class="date-text">
               Último valor:<span id="measuring-date"> {{ fechaUltimaIndicador | dateMonthYear | capitalize }}</span>
              </span>
          </div>
        </div>
        <div v-if="chartData.length && variacionIndicador!=='No hay valor'" class="measuring-container col-12 text-right">
            <span
              v-if="isNegativeNumber(variacionIndicador)"
              id="measuring-date"
            >
              <q-icon name="arrow_drop_down" />
              Ha descendido
            </span>
            <span v-else id="measuring-date">
              <q-icon name="arrow_drop_up" />
              Ha aumentado
            </span>
            <span id="measuring-date">
              {{ parseFloat(variacionIndicador).toFixed(2) }} {{ unidadMedidaIndicador }} desde {{ fechaAnteriorIndicador | dateMonthYear | capitalize }}
            </span>
        </div>
      </div>
      <div class="row text-center" :style="chartData.length < 1 ? 'height: 87%;' : (recomendadoIndicador===undefined ? 'height: 80%;' : 'height: 67%;')">
        <div v-if="chartData.length > 1" class="col-12">
          <LineChart
          :height="145"
          :chartData="chartData"
          :periodData="periodData"
          :recomendado="recomendadoIndicador"
          :datosObjetivo ="datosObjetivo"
          :tipoRecomendado="tipoRecomendado"
          :recomendadoPor="recomendadoPorIndicador"
          :unidadMedida="unidadMedidaIndicador"/>
        </div>
        <div v-if="chartData.length < 1" class="noData col-12">NO HAY DATOS DISPONIBLES</div>
      </div>
      <div v-if="datoObjetivo !== null && chartData.length <= 1" class="row col-12 divObjetivoLegend">
        <span class="objetivoLegend"> <hr class="line" />Objetivo: {{ datoObjetivo }} {{ unidadMedida }} <span class="fechaObjetivoLegend"> para {{ fechaDatoObjetivo | dateMonthYear | capitalize }}</span></span>
      </div>
    </q-card>
  </div>
  <div v-else class="container-indicador">
    <div class="row containerHeader">
      <div class="col-3 title"></div>
      <div class=" measuring-container col-12 text-right">
        <div v-if="chartData.length > 0" class="col-12">
          <span class="measuring">
            <span v-if='formatNameZona(dataIndicador.limitesMunicipio.nombre, 0)!=="M"'>{{formatNameZona(dataIndicador.limitesMunicipio.nombre, 1)}}: </span>
            <span v-else>Municipio: </span>
            <span v-if="valueIndicadorFiltered===null" id="measuring-big">{{ String(parseFloat(valueIndicador).toFixed(2)) }} </span>
            <span v-else id="measuring-big">{{ String(parseFloat(valueIndicadorComputedFiltered).toFixed(2)) }} </span>
          </span>
          <span id="measuring-unit-big">{{ unidadMedidaIndicador }}</span>
        </div>
        <div class="col-12">
          <span v-if="fechaUltimaIndicadorFiltered===null" id="measuring-date-big">{{ fechaUltimaIndicador | dateMonthYear | capitalize }}</span>
          <span v-else id="measuring-date-big">{{ fechaUltimaIndicadorComputedFiltered | dateMonthYear | capitalize }}</span>
        </div>
        <div v-if="chartData.length > 0" class="col-12">
          <span v-if="variacionIndicadorFiltered!=='No hay valor' && variacionIndicador !=='No hay valor'">
            <span
              v-if="valueIndicadorComputedFiltered!==null? isNegativeNumber(variacionIndicadorFiltered) : isNegativeNumber(variacionIndicador)"
              id="measuring-date-big"
            >
              <q-icon class="q-icon-big" name="arrow_drop_down" />
              Ha descendido
            </span>
            <span v-else id="measuring-date">
              <q-icon class="q-icon-big" name="arrow_drop_up" />
              Ha aumentado
            </span>
          </span>
          <span v-if="variacionIndicadorFiltered===null && variacionIndicador !=='No hay valor' " id="measuring-date">
            {{ parseFloat(variacionIndicador).toFixed(2) }} {{ unidadMedidaIndicador }} desde {{ fechaAnteriorIndicador | dateMonthYear | capitalize }}
          </span>
          <span v-else-if="variacionIndicadorFiltered==='No hay valor' || variacionIndicador === 'No hay valor'" id="measuring-date">
            No hay variación
          </span>
          <span v-else id="measuring-date">
            {{ parseFloat(variacionIndicadorFiltered).toFixed(2) }} {{ unidadMedidaIndicador }} desde {{ fechaAnteriorIndicadorComputedFiltered | dateMonthYear | capitalize }}
          </span>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div v-if="chartData.length > 0" class="col-12">
        <LineChart
        :height="350"
        :chartData="chartFiltered.length > 0 ? chartFiltered : chartData"
        :periodData="periodData"
        :recomendado="recomendadoIndicador"
        :tipoRecomendado="tipoRecomendado"
        :recomendadoPor="recomendadoPorIndicador"
        :datosObjetivo ="datosObjetivo"
        :unidadMedida="unidadMedidaIndicador"
        />
      </div>
      <div v-else class="noData col-12">NO HAY DATOS DISPONIBLES</div>
    </div>

    <DialogCreate
      v-model="showDialogFilter"
      labelSuccess="Cerrar"
      :showBottonCancel="false"
      dataCy="popUpFilter"
      @save="aceptar()"
    >
      <template slot="body">
        <div class="noData title-option text-center">
          No hay datos disponibles para el rango seleccionado
        </div>
      </template>
    </DialogCreate>
  </div>
</template>

<script>
import Formats from '../../shared/mixins/Formats';
import LineChart from '@/shared/charts/LineChart.vue';
import moment from 'moment';
import DialogCreate from '@/shared/dialogs/create/DialogCreate.vue';
import * as types from '@/storeModules/NGUD/types';

export default {
  components: {
    LineChart,
    DialogCreate
  },
  props: {
    dataIndicador: Object,
    showLittleTag: {
      type: Boolean,
      default: () => false
    },
    datosObjetivo: {
      type: Object,
      default: () => null
    },
    idRelacionAUE: {
      type: String,
      default: () => null
    },
    disableOpenURL: {
      type: Boolean,
      default: () => false
    }
  },
  mixins: [Formats],
  data () {
    return {
      nameIndicador: '',
      valueIndicador: null,
      unidadMedidaIndicador: '',
      fechaUltimaIndicador: '',
      fechaAnteriorIndicador: '',
      variacionIndicador: '',
      recomendadoPorIndicador: '',
      recomendadoIndicador: null,
      tipoRecomendado: null,
      chartData: [],
      chartFiltered: [],
      valueIndicadorFiltered: null,
      variacionIndicadorFiltered: null,
      fechaUltimaIndicadorFiltered: null,
      fechaAnteriorIndicadorFiltered: null,
      showDialogFilter: false,
      fechaIniFiltered: null,
      fechaFinFiltered: null,
      fechaInicioMunicipal: null,
      fechaFinMunicipal: null,
      watchPassed: false,
      datoObjetivo: null,
      fechaDatoObjetivo: null,
      unidadMedida: null,
      periodData: 'month'
    };
  },
  created () {
    this.fillData();
    if (this.dataIndicador.hasOwnProperty('fechaInicio') && this.dataIndicador.hasOwnProperty('fechaFin')) {
      let dateInicioSimple = this.dataIndicador.fechaInicio.split('T');
      let dateFinSimple = this.dataIndicador.fechaFin.split('T');
      this.fechaInicioMunicipal = moment(dateInicioSimple[0]).format('YYYY/MM/DD');
      this.fechaFinMunicipal = moment(dateFinSimple[0]).format('YYYY/MM/DD');
    }
    this.unidadMedidaIndicador = this.dataIndicador.unidadMedida;
    this.recomendadoPorIndicador = this.dataIndicador.recomendadoPor;
    this.recomendadoIndicador = this.dataIndicador.minimoRecomendado !== undefined ? this.dataIndicador.minimoRecomendado : this.dataIndicador.maximoRecomendado;
    this.tipoRecomendado = this.dataIndicador.minimoRecomendado !== undefined ? 'Mínimo Recomendado' : 'Máximo Recomendado';
    this.changeDataPeriod();
  },
  watch: {
    dataIndicador () {
      this.watchPassed = true;
      this.fillData();
    }
  },
  computed: {
    valueIndicadorComputedFiltered () {
      return this.valueIndicadorFiltered;
    },
    variacionIndicadorComputedFiltered () {
      return this.variacionIndicadorFiltered;
    },
    fechaUltimaIndicadorComputedFiltered () {
      return this.fechaUltimaIndicadorFiltered;
    },
    fechaAnteriorIndicadorComputedFiltered () {
      return this.fechaAnteriorIndicadorFiltered;
    }
  },
  mounted () {
    this.$eventHub.$on('filterRangeOfDates', (fechaInicial, fechaFinal) => {
      this.fechaIniFiltered = fechaInicial;
      this.fechaFinFiltered = fechaFinal;
      this.filterChart(fechaInicial, fechaFinal);
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('filterRangeOfDates');
  },
  methods: {
    changeDataPeriod () {
      switch (this.dataIndicador.periodicidad) {
        case 'Mensual':
          this.periodData = 'month';
          break;
        case 'Revisión Mensual':
          this.periodData = 'month';
          break;
        case 'Anual':
          this.periodData = 'year';
          break;
        case 'Revisión Anual':
          this.periodData = 'year';
          break;
        default:
          this.periodData = 'month';
          break;
      }
    },
    formatNameZona (name, element) {
      var nameArray = name.split('_');
      return nameArray[element];
    },
    isNegativeNumber (variation) {
      return variation < 0;
    },
    openURL () {
      if (!this.disableOpenURL) {
        this.$store.commit(types.MUTATE_SET_LOOP_INDICATORS, {});
        this.$router.push({
          name: 'detalle_indicador',
          params: { idIndicador: this.dataIndicador.hasOwnProperty('idIndicador') ? this.dataIndicador.idIndicador : this.dataIndicador.id, idRelacionAUE: this.dataIndicador.hasOwnProperty('idIndicador') ? this.idRelacionAUE : null }
        });
      }
    },
    fillData () {
      if (this.datosObjetivo !== null) {
        this.datoObjetivo = this.datosObjetivo.datoObjetivo;
        this.fechaDatoObjetivo = this.datosObjetivo.fechaDatoObjetivo;
        this.unidadMedida = this.datosObjetivo.unidadMedida;
      }
      // diferenciar modelo tarjeta pequeña de modelo detalle
      if (this.dataIndicador.hasOwnProperty('datosGraficaMunicipal')) {
        this.fillOptionalData();
      } else {
        this.nameIndicador = this.dataIndicador.name;
        this.fillOptionalDataLittleTag();
      }
    },
    filterChart (fechaInicial, fechaFinal) {
      let posInicial = this.filterDateIni(fechaInicial);
      let posFinal = this.filterDateFin(fechaFinal);
      if (posInicial !== -1 && posFinal !== -1 && posFinal >= posInicial) {
        this.fillChartFiltered(posInicial, posFinal);
      } else {
        this.showDialogFilter = true;
      }
    },
    filterDateIni (fechaInicial) {
      let posInicial = -1;
      for (let i = 0; i < this.chartData.length && posInicial === -1; i++) {
        let dateIniSimple = this.chartData[i].date.split('T');
        if ((moment(dateIniSimple[0]).format('YYYY/MM/DD')) >= fechaInicial) {
          posInicial = i;
        }
      }
      return posInicial;
    },
    filterDateFin (fechaFinal) {
      let posFinal = -1;
      for (let i = this.chartData.length - 1; i >= 0 && posFinal === -1; i--) {
        let dateFinSimple = this.chartData[i].date.split('T');
        if ((moment(dateFinSimple[0]).format('YYYY/MM/DD')) <= fechaFinal) {
          posFinal = i;
        }
      }
      return posFinal;
    },
    fillChartFiltered (posInicial, posFinal) {
      this.chartFiltered = [];
      for (let i = posInicial; i <= posFinal; i++) {
        this.chartFiltered.push(this.chartData[i]);
      }
      this.fillDataHeaderChart();
    },
    fillDataHeaderChart () {
      let lastvalue = this.chartFiltered[this.chartFiltered.length - 1].value;
      this.fechaUltimaIndicadorFiltered = this.chartFiltered[this.chartFiltered.length - 1].date;
      this.valueIndicadorFiltered = lastvalue;
      // depende de que haya mas de un valor
      if (this.chartFiltered.length > 1) {
        let penultimatevalue = this.chartFiltered[this.chartFiltered.length - 2].value;
        this.fechaAnteriorIndicadorFiltered = this.chartFiltered[this.chartFiltered.length - 2].date;
        this.variacionIndicadorFiltered = String(lastvalue - penultimatevalue);
      } else {
        this.variacionIndicadorFiltered = 'No hay valor';
      }
    },
    aceptar () {
      this.showDialogFilter = false;
    },
    fillOptionalDataLittleTag () {
      this.valueIndicador = this.dataIndicador.hasOwnProperty('value') ? this.dataIndicador.value : null;
      this.fechaUltimaIndicador = this.dataIndicador.hasOwnProperty('fechaUltima') ? this.dataIndicador.fechaUltima : null;
      if (this.dataIndicador.valoresGrafica.length > 1) {
        this.fillOptionalDataHistoryLittleTag();
      } else {
        this.variacionIndicador = 'No hay valor';
      }
      this.chartData = this.dataIndicador.hasOwnProperty('valoresGrafica') ? this.dataIndicador.valoresGrafica : [];
      this.roundCharData2Decimals();
    },
    fillOptionalData () {
      this.chartData = this.dataIndicador.datosGraficaMunicipal.valoresGrafica;
      this.roundCharData2Decimals();
      if (this.watchPassed === false) {
        this.fechaUltimaIndicador = (this.dataIndicador.datosGraficaMunicipal.valoresGrafica[this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length - 1].date);
        this.valueIndicador = this.dataIndicador.datosGraficaMunicipal.ultimoValorDelHistorico;
        if (this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length > 1) {
          this.fillOptionalDataHistory();
        } else {
          this.variacionIndicador = 'No hay valor';
        }
      } else {
        this.filterChartZone();
      }
    },
    filterChartZone () {
      if (this.fechaIniFiltered === null && this.fechaFinFiltered === null) {
        this.filterChart(this.fechaInicioMunicipal, this.fechaFinMunicipal);
      } else {
        this.filterChart(this.fechaIniFiltered, this.fechaFinFiltered);
      }
    },
    fillOptionalDataHistoryLittleTag () {
      this.fechaAnteriorIndicador = this.dataIndicador.hasOwnProperty('fechaAnterior') ? this.dataIndicador.fechaAnterior : null;
      this.variacionIndicador = this.dataIndicador.hasOwnProperty('variacion') ? this.dataIndicador.variacion : null;
    },
    fillOptionalDataHistory () {
      this.fechaAnteriorIndicador = (this.dataIndicador.datosGraficaMunicipal.valoresGrafica[this.dataIndicador.datosGraficaMunicipal.valoresGrafica.length - 2].date);
      this.variacionIndicador = this.dataIndicador.datosGraficaMunicipal.variacion;
    },
    roundCharData2Decimals () {
      for (let i = 0; i < this.chartData.length; i++) {
        this.chartData[i].value = parseFloat(this.chartData[i].value).toFixed(2);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container-indicador.shadow-1{
  padding: 15px 25px 25px 25px;
}
.noData{
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -1.13px;
  color: $seafoam-blue-hover;
}
.container-indicador {
  background-color: #ffffff;
  min-height: 232px;
  height: 350px;
  padding: 0px 0px 17px 0px;

  .text-center {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .containerHeader {
    word-wrap: break-word;

    .title {
      font-family: DINPro;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.64px;
      color: #002f6c;
      padding-right: 10px;
    }

    .measuring-container {
      font-family: DINPro;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      .measuring {
        font-size: 28px;
        font-weight: bold;
        letter-spacing: -1.13px;
        color: $seafoam-blue-hover;
        #measuring-big {
          font-size: 40px;
        }
      }
      #measuring-unit {
        font-size: 14px;
        font-weight: bold;
        letter-spacing: -0.56px;
        color: $seafoam-blue-hover;
      }
      #measuring-unit-big {
        font-size: 20px;
        font-weight: bold;
        letter-spacing: -0.56px;
        color: $seafoam-blue-hover;
      }
      #measuring-date-big {
        font-size: 14px;
        font-weight: bold;
        letter-spacing: -0.48px;
        color: #454545;
      }
      #measuring-date {
        font-size: 12px;
        font-weight: bold;
        letter-spacing: -0.48px;
        color: #454545;
      }
      .date-text{
        font-size: 12px;
        letter-spacing: -0.48px;
        color: #454545;
      }
    }
  }

  #limit-value {
    font-family: DINPro;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.48px;
    color: #2175a8;
  }

  #more-info {
    font-family: DINPro;
    font-size: 10px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.4px;
    color: #454545;
    text-transform: uppercase;
  }
  .q-icon{
    font-size: 1.5em;
  }
  .q-icon-big{
    font-size: 2.3em;
  }
  .divObjetivoLegend {
    display: flex;
    align-self: flex-end;
  }
  .objetivoLegend, .fechaObjetivoLegend{
    font-family: DINPro;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.48px;
  }
  .objetivoLegend {
    color: #37b0be;
    display: flex;
  }
  .fechaObjetivoLegend{
    color: #454545;
    margin-left: 5px;
  }
  .line {
    height: 2px;
    width: 15px;
    background-color: #37b0be;
    border-style: none;
    margin-right: 10px;
    align-self: center;
  }
}
</style>
